import styled from 'styled-components';
import { px2rem } from '../../utils/helpers/style.js';
import { styles } from '../../constants/styles.js';

var wrapper = /*#__PURE__*/styled.a.withConfig({
  displayName: "styles__wrapper",
  componentId: "sc-1j2njep-0"
})(["color:", ";svg{height:", ";", "{height:", ";}}"], function (props) {
  return props.$highlightColor;
}, px2rem(60), styles.breakpoint.s, px2rem(80));

export { wrapper };
